module.exports = __webpack_public_path__ + "img/s4-dialog.71c4a3f1.png";